import { t } from 'ttag';

const inititalDataTable1 = [
  {
    key: '1',
    arrhythmiaSession: t`DY after 24 hours`,
    af1: {
      n: 127,
      dy: 17.84,
      cl: '15.17-20.92',
    },
    af10: {
      n: 354,
      dy: 28.15,
      cl: '25.72-30.76',
    },
    pvcs: {
      n: 87,
      dy: 40.09,
      cl: '33.92-46.93',
    },
    nsvt: {
      n: 194,
      dy: 11.39,
      cl: '9.97-13.00',
    },
    vt30: {
      n: 2,
      dy: 11.11,
      cl: '2.90-37.58',
    },
    avb: {
      n: 107,
      dy: 41.63,
      cl: '35.88-47.91',
    },
    pause: {
      n: 111,
      dy: 20.4,
      cl: '17.25-24.04',
    },
    bradycardia: {
      n: 224,
      dy: 28.72,
      cl: '25.68-32.03',
    },
  },
  {
    key: '2',
    arrhythmiaSession: t`DY after 48 hours`,
    af1: {
      n: 201,
      dy: 28.22,
      cl: '25.00-31.75',
    },
    af10: {
      n: 505,
      dy: 40.18,
      cl: '37.49-42.99',
    },
    pvcs: {
      n: 106,
      dy: 48.85,
      cl: '42.43-55.69',
    },
    nsvt: {
      n: 343,
      dy: 20.14,
      cl: '18.31-22.13',
    },
    vt30: {
      n: 2,
      dy: 11.11,
      cl: '2.90-37.58',
    },
    avb: {
      n: 128,
      dy: 49.81,
      cl: '43.88-56.07',
    },
    pause: {
      n: 178,
      dy: 32.72,
      cl: '28.95-36.84',
    },
    bradycardia: {
      n: 322,
      dy: 41.28,
      cl: '37.92-44.82',
    },
  },
  {
    key: '3',
    arrhythmiaSession: t`DY after 5 days`,
    af1: {
      n: 343,
      dy: 48.1,
      cl: '44.43-51.91',
    },
    af10: {
      n: 758,
      dy: 60.31,
      cl: '57.58-63.06',
    },
    pvcs: {
      n: 145,
      dy: 66.82,
      cl: '60.53-73.00',
    },
    nsvt: {
      n: 686,
      dy: 40.28,
      cl: '38.00-42.65',
    },
    vt30: {
      n: 8,
      dy: 44.44,
      cl: '25.25-69.49',
    },
    avb: {
      n: 161,
      dy: 62.65,
      cl: '56.76-68.54',
    },
    pause: {
      n: 317,
      dy: 58.27,
      cl: '54.17-62.44',
    },
    bradycardia: {
      n: 483,
      dy: 61.92,
      cl: '58.53-65.33',
    },
  },
  {
    key: '4',
    arrhythmiaSession: t`DY after 7 days`,
    af1: {
      n: 409,
      dy: 57.31,
      cl: '53.64-61.04',
    },
    af10: {
      n: 857,
      dy: 68.25,
      cl: '65.63-70.84',
    },
    pvcs: {
      n: 159,
      dy: 73.27,
      cl: '67.26-78.97',
    },
    nsvt: {
      n: 887,
      dy: 52.08,
      cl: '49.73-54.48',
    },
    vt30: {
      n: 10,
      dy: 55.56,
      cl: '34.88-78.42',
    },
    avb: {
      n: 181,
      dy: 70.43,
      cl: '64.78-75.89',
    },
    pause: {
      n: 368,
      dy: 67.65,
      cl: '63.70-71.54',
    },
    bradycardia: {
      n: 536,
      dy: 68.72,
      cl: '65.45-71.94',
    },
  },
  {
    key: '5',
    arrhythmiaSession: t`DY after 14 days`,
    af1: {
      n: 590,
      dy: 82.75,
      cl: '79.82-85.48',
    },
    af10: {
      n: 1106,
      dy: 88.05,
      cl: '86.16-89.80',
    },
    pvcs: {
      n: 186,
      dy: 85.71,
      cl: '80.71-89.98',
    },
    nsvt: {
      n: 1308,
      dy: 76.81,
      cl: '74.78-78.78',
    },
    vt30: {
      n: 14,
      dy: 77.78,
      cl: '57.12-93.09',
    },
    avb: {
      n: 223,
      dy: 86.77,
      cl: '82.32-90.57',
    },
    pause: {
      n: 472,
      dy: 86.76,
      cl: '83.77-89.45',
    },
    bradycardia: {
      n: 669,
      dy: 85.77,
      cl: '83.22-88.11',
    },
  },
  {
    key: '6 ',
    arrhythmiaSession: t`DY after 30 days`,
    af1: {
      n: 713,
      dy: 100.0,
      cl: '--',
    },
    af10: {
      n: 1256,
      dy: 100.0,
      cl: '--',
    },
    pvcs: {
      n: 217,
      dy: 100.0,
      cl: '--',
    },
    nsvt: {
      n: 1703,
      dy: 100.0,
      cl: '--',
    },
    vt30: {
      n: 18,
      dy: 100.0,
      cl: '--',
    },
    avb: {
      n: 257,
      dy: 100.0,
      cl: '--',
    },
    pause: {
      n: 544,
      dy: 100.0,
      cl: '--',
    },
    bradycardia: {
      n: 780,
      dy: 100.0,
      cl: '--',
    },
  },
];

const inititalDataTable2 = [
  {
    key: '1',
    arrhythmiaSession: t`DY after 24 hours`,
    af1: {
      n: 99,
      dy: 18.66,
      cl: '15.54-22.33',
    },
    af10: {
      n: 301,
      dy: 28.84,
      cl: '26.16-31.73',
    },
    pvcs: {
      n: 162,
      dy: 44.51,
      cl: '39.57-49.77',
    },
    nsvt: {
      n: 406,
      dy: 17.17,
      cl: '15.71-18.75',
    },
    vt30: {
      n: 6,
      dy: 17.14,
      cl: '8.09-34.23',
    },
    avb: {
      n: 177,
      dy: 49.44,
      cl: '44.40-54.73',
    },
    pause: {
      n: 179,
      dy: 26.68,
      cl: '23.50-30.19',
    },
    bradycardia: {
      n: 426,
      dy: 35.89,
      cl: '33.23-38.69',
    },
  },
  {
    key: '2',
    arrhythmiaSession: t`DY after 48 hours`,
    af1: {
      n: 150,
      dy: 28.29,
      cl: '24.59-32.42',
    },
    af10: {
      n: 423,
      dy: 40.55,
      cl: '37.60-43.64',
    },
    pvcs: {
      n: 198,
      dy: 54.4,
      cl: '49.37-59.58',
    },
    nsvt: {
      n: 638,
      dy: 26.98,
      cl: '25.24-28.81',
    },
    vt30: {
      n: 13,
      dy: 37.14,
      cl: '23.53-55.23',
    },
    avb: {
      n: 213,
      dy: 59.5,
      cl: '54.46-64.60',
    },
    pause: {
      n: 247,
      dy: 36.81,
      cl: '33.29-40.58',
    },
    bradycardia: {
      n: 571,
      dy: 48.1,
      cl: '45.30-50.99',
    },
  },
  {
    key: '3',
    arrhythmiaSession: t`DY after 5 days`,
    af1: {
      n: 266,
      dy: 50.1,
      cl: '45.84-54.52',
    },
    af10: {
      n: 639,
      dy: 61.22,
      cl: '58.23-64.22',
    },
    pvcs: {
      n: 265,
      dy: 72.8,
      cl: '68.16-77.27',
    },
    nsvt: {
      n: 1125,
      dy: 47.57,
      cl: '45.58-49.60',
    },
    vt30: {
      n: 19,
      dy: 54.29,
      cl: '38.95-71.10',
    },
    avb: {
      n: 265,
      dy: 74.02,
      cl: '69.39-78.45',
    },
    pause: {
      n: 384,
      dy: 57.23,
      cl: '53.52-60.99',
    },
    bradycardia: {
      n: 797,
      dy: 67.14,
      cl: '64.46-69.80',
    },
  },
  {
    key: '4',
    arrhythmiaSession: t`DY after 7 days`,
    af1: {
      n: 319,
      dy: 60.12,
      cl: '55.89-64.38',
    },
    af10: {
      n: 735,
      dy: 70.37,
      cl: '67.55-73.15',
    },
    pvcs: {
      n: 290,
      dy: 79.67,
      cl: '75.39-83.63',
    },
    nsvt: {
      n: 1366,
      dy: 57.76,
      cl: '55.78-59.76',
    },
    vt30: {
      n: 23,
      dy: 65.71,
      cl: '50.21-80.66',
    },
    avb: {
      n: 285,
      dy: 79.61,
      cl: '75.29-83.61',
    },
    pause: {
      n: 446,
      dy: 66.47,
      cl: '62.89-70.02',
    },
    bradycardia: {
      n: 892,
      dy: 75.15,
      cl: '72.66-77.57',
    },
  },
  {
    key: '5',
    arrhythmiaSession: t`DY after 14 days`,
    af1: {
      n: 429,
      dy: 80.94,
      cl: '77.42-84.23',
    },
    af10: {
      n: 902,
      dy: 86.42,
      cl: '84.23-88.44',
    },
    pvcs: {
      n: 339,
      dy: 93.13,
      cl: '90.23-95.43',
    },
    nsvt: {
      n: 1932,
      dy: 81.69,
      cl: '80.11-83.22',
    },
    vt30: {
      n: 25,
      dy: 71.43,
      cl: '56.16-85.09',
    },
    avb: {
      n: 319,
      dy: 89.11,
      cl: '85.62-92.07',
    },
    pause: {
      n: 574,
      dy: 85.54,
      cl: '82.77-88.08',
    },
    bradycardia: {
      n: 1073,
      dy: 90.4,
      cl: '88.54-91.99',
    },
  },
  {
    key: '6 ',
    arrhythmiaSession: t`DY after 30 days`,
    af1: {
      n: 530,
      dy: 100.0,
      cl: '--',
    },
    af10: {
      n: 1044,
      dy: 100.0,
      cl: '--',
    },
    pvcs: {
      n: 364,
      dy: 100.0,
      cl: '--',
    },
    nsvt: {
      n: 2365,
      dy: 100.0,
      cl: '--',
    },
    vt30: {
      n: 35,
      dy: 100.0,
      cl: '--',
    },
    avb: {
      n: 358,
      dy: 100.0,
      cl: '--',
    },
    pause: {
      n: 671,
      dy: 100.0,
      cl: '--',
    },
    bradycardia: {
      n: 1187,
      dy: 100.0,
      cl: '--',
    },
  },
];

const referenceList = [
  {
    url: 'https://www.ahajournals.org/doi/10.1161/CIRCULATIONAHA.108.825380',
    title:
      'Benjamin, Emelia J et al. “Prevention of atrial fibrillation: report from a national heart, lung, and blood institute workshop.” Circulation vol. 119,4 (2009): 606-18.',
    subTitle: 'doi:10.1161/CIRCULATIONAHA.108.825380',
  },
  {
    url: 'https://www.hindawi.com/journals/apm/2019/8392348/',
    title:
      'Jia, Xiaona, et al. "A cox-based risk prediction model for early detection of cardiovascular disease: identification of key risk factors for the development of a 10-Year CVD risk prediction." Advances in preventive medicine 2019 (2019).​',
    subTitle: '',
  },
  {
    url: 'https://academic.oup.com/europace/article/25/1/185/6763073?login=false',
    title:
      'Kalarus, Zbigniew et al. “Searching for atrial fibrillation: looking harder, looking longer, and in increasingly sophisticated ways. An EHRA position paper.” Europace : European pacing, arrhythmias, and cardiac electrophysiology : journal of the working groups on cardiac pacing, arrhythmias, and cardiac cellular electrophysiology of the European Society of Cardiology vol. 25,1 (2023): 185-198.',
    subTitle: 'doi:10.1093/europace/euac144',
  },
  {
    url: 'https://www.ahajournals.org/doi/10.1161/HCQ.0000000000000105',
    title:
      'Kini, Vinay et al. “Strategies to Reduce Low-Value Cardiovascular Care: A Scientific Statement From the American Heart Association.” Circulation. Cardiovascular quality and outcomes vol. 15,3 (2022): e000105.',
    subTitle: 'doi:10.1161/HCQ.0000000000000105',
  },
  {
    url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8756007/#:~:text=A%205%2DmmHg%20reduction%20of,high%2Dnormal%20blood%20pressure%20values',
    title:
      '“Lowering blood pressure significantly reduces cardiovascular risk even at normal levels.” Cardiovascular Journal of Africa vol. 32,6 (2021): 319–326.',
    subTitle: '',
  },
  {
    url: 'https://www.ahajournals.org/doi/10.1161/HYPERTENSIONAHA.120.15492',
    title:
      'Margolis, Karen L et al. “Cardiovascular Events and Costs With Home Blood Pressure Telemonitoring and Pharmacist Management for Uncontrolled Hypertension.” Hypertension (Dallas, Tex. : 1979) vol. 76,4 (2020): 1097-1103.',
    subTitle: 'doi:10.1161/HYPERTENSIONAHA.120.15492',
  },
  {
    url: 'https://www.sciencedirect.com/science/article/abs/pii/S0033062013001746?via%3Dihub',
    title:
      'Rosero, Spencer Z., et al. "Ambulatory ECG monitoring in atrial fibrillation management." Progress in cardiovascular diseases 56.2 (2013): 143-152.',
    subTitle: '',
  },
  {
    url: 'https://bmccardiovascdisord.biomedcentral.com/articles/10.1186/s12872-016-0210-x',
    title:
      'Solomon, Matthew D et al. “Incidence and timing of potentially high-risk arrhythmias detected through long term continuous ambulatory electrocardiographic monitoring.” BMC cardiovascular disorders vol. 16 35. 17 Feb. 2016,',
    subTitle: 'doi:10.1186/s12872-016-0210-x',
  },
  {
    url: 'https://escholarship.org/uc/item/50f7t7k5#main',
    title:
      'Schreiber, Donald, et al. "Ambulatory cardiac monitoring for discharged emergency department patients with possible cardiac arrhythmias." Western Journal of Emergency Medicine 15.2 (2014): 194.​',
    subTitle: '',
  },
  {
    url: 'https://www.heartrhythmjournal.com/article/S1547-5271(16)30004-2/abstract',
    title:
      'Siontis, Konstantinos C et al. “Typical, atypical, and asymptomatic presentations of new-onset atrial fibrillation in the community: Characteristics and prognostic implications.” Heart rhythm vol. 13,7 (2016): 1418-24.',
    subTitle: 'doi:10.1016/j.hrthm.2016.03.003​',
  },
  {
    url: 'https://www.sciencedirect.com/science/article/pii/S1050173819301495',
    title: 'https://www.sciencedirect.com/science/article/pii/S1050173819301495',
    subTitle: '',
  },
];

export { inititalDataTable1, inititalDataTable2, referenceList };
